import { render } from "./Mb004.vue?vue&type=template&id=e583bd98&scoped=true"
import script from "./Mb004.vue?vue&type=script&lang=js"
export * from "./Mb004.vue?vue&type=script&lang=js"

import "./Mb004.vue?vue&type=style&index=0&id=e583bd98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e583bd98"]])

export default __exports__